import { forwardRef } from "react";
import Link from "next/link";
import { cn } from "~/lib/utils";
import { ChevronRightIcon } from "~/components/icons";

export interface BreadcrumbItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
}

export interface BreadcrumbProps extends React.HTMLAttributes<HTMLDivElement> {
  items: BreadcrumbItem[];
  currentPage: string;
}

const Breadcrumb = forwardRef<HTMLDivElement, BreadcrumbProps>(
  ({ className, items, currentPage, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex items-center gap-1", className)}
        {...props}
      >
        {items.map((item, index) => (
          <div key={index} className="flex items-center gap-1 p-1">
            {item.icon && (
              <div className="flex h-4 w-4 items-center justify-center">
                {item.icon}
              </div>
            )}
            {item.href ? (
              <Link
                href={item.href}
                className="text-sm leading-5 text-[rgba(0,0,0,0.7)] hover:text-[#1c2024]"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-sm leading-5 text-[rgba(0,0,0,0.7)]">
                {item.label}
              </span>
            )}
            <ChevronRightIcon className="h-5 w-5 text-[#1c2024]" />
          </div>
        ))}
        <div className="flex items-center gap-1 rounded bg-[rgba(0,85,199,0.04)] px-2 py-1">
          <span className="text-sm leading-5 text-[#1c3144]">
            {currentPage}
          </span>
        </div>
      </div>
    );
  }
);

Breadcrumb.displayName = "Breadcrumb";

export { Breadcrumb };

